import { Outlet, createFileRoute } from '@tanstack/react-router';

import { ProductLogoMediumUserAccounts as LogoPersons } from '@/components/Logo';
import type { TabWithIndicatorProps } from '@/components/Navigation/HeaderTabs';
import { ProductHeader } from '@/components/ProductHeader';
import { useTranslation } from '@/lib/i18n';

export const Route = createFileRoute('/_staff/settings/persons/_list')({
  component: Persons,
});

function Persons() {
  const { t } = useTranslation();

  const tabs = [
    {
      to: '/settings/persons/staff',
      // NOTE" バックエンド上はoperatorという名前で管理されている
      children: t('common.list.persons.operator'),
    },
    {
      to: '/settings/persons/individual',
      children: t('common.list.persons.individual'),
    },
    {
      to: '/settings/persons/settings',
      children: t('common.list.persons.settings'),
    },
  ] satisfies TabWithIndicatorProps[];

  return (
    <div className="flex flex-col">
      <ProductHeader
        Logo={LogoPersons}
        name={t('pages.settings.persons.title')}
        tabs={tabs}
        type="resource"
      />
      <Outlet />
    </div>
  );
}
